export default {"src":"/_next/static/media/kotlin-logo.017dce84.svg","height":29,"width":130,"blurWidth":0,"blurHeight":0};